import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fffdebeoasudmbilnjbg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmZmRlYmVvYXN1ZG1iaWxuamJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1MTgxMzEsImV4cCI6MjA3NjA5NDEzMX0.FTTg9mf2n0ZH_k1YkSTxw6FjbThzDZQgIdHuPsJ8kL4';

// Client singleton
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // Importante: rileva automaticamente la sessione nell'URL
    flowType: 'pkce' // Usa PKCE per maggiore sicurezza
  },
  db: {
    schema: 'public'
  }
});

// Costanti configurazione
export const CACHE_TTL_MONTHS = 2; // 2 mesi come richiesto
export const CACHE_TTL_MS = CACHE_TTL_MONTHS * 30 * 24 * 60 * 60 * 1000; // millisecondi
export const SIMILAR_ARTISTS_COUNT = 50; // Numero artisti simili da Gemini

export default supabase;






















